const route = [
    {//选择作业类型
        //subject：91小学  92初中
        path: '/englishChooseType/:subject',
        component: function (resolve) {
            require(['VIEWS/english/chooseTaskType.vue'], resolve);
        }
    },
    {//发作业页面  // type:1,2,3
        // 小学# 1:课文预习 2 同步习题 3 高频错题
        // 初中# 2 同步习题 3 高频错题
        // sid  学科类型 91,92
        path: '/english/release/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/english/module/release.vue'], resolve);
        }
    },
];
export default route
